import { render, staticRenderFns } from "./qygl.vue?vue&type=template&id=4fa2b3e4&"
import script from "./qygl.vue?vue&type=script&lang=js&"
export * from "./qygl.vue?vue&type=script&lang=js&"
import style0 from "./qygl.vue?vue&type=style&index=0&id=4fa2b3e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports